export const STORAGE_KEY = 'mail2many-superadmin'

let syncedData = {
  isLayerOpened: false,
  // locale used for moment, i18n, and various
  locale: 'de',
  // fullLocale is the ISO version of locale
  fullLocale: 'de-DE',
  scrollState: {},
  searchState: {},
}

const notSyncedData = {

}

// Sync with local storage.
if (localStorage.getItem(STORAGE_KEY)) {
  syncedData = JSON.parse(localStorage.getItem(STORAGE_KEY))
}

// Merge data and export it.
export const state = Object.assign(syncedData, notSyncedData)



// WEBPACK FOOTER //
// ./src/store/state.js